import React from "react";
import './HeaderStudents.css';
import { Upload, UserPlus } from "lucide-react";

export function HeaderStudents({ onOpenAddStudentModal }) {
    return (
        <div className="alunos-header">
            <div className="alunos-header-title-container">
                <h1 className="alunos-header-title">Alunos</h1>
                <p className="alunos-header-description">Gerencie e visualize informações dos alunos</p>
            </div>
            <div className="alunos-header-buttons-container">
                <button className="alunos-header-button alunos-header-button-import">
                    <Upload className="alunos-header-button-icon" size={16}/>
                    Importar
                </button>
                <button 
                    className="alunos-header-button alunos-header-button-add"
                    onClick={onOpenAddStudentModal}
                >
                    <UserPlus className="alunos-header-button-icon" size={16}/>
                    Adicionar Aluno
                </button>
            </div>
        </div>
    );
}